package com.willandsons.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.text.SpanText
import com.willandsons.components.layouts.PageLayoutData
import com.willandsons.components.widgets.AppCard
import org.jetbrains.compose.web.css.em

@InitRoute
fun initAppsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Apps"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun AppsPage() {
    Column(
        modifier = Modifier.margin(right = 2.em)
    ) {
        AppCard(
            titleContent = {
//                Image("/lovenearby-logo.svg", modifier = Modifier.size(2.2.cssRem))
                SpanText("LoveNearby")
            },
            description = "Discover love near you.",
            status = "Closed Beta",
            statusColor = Colors.Yellow,
            borderColor = Color.rgb(0xff3862),
            googlePlayLink = null,
            appStoreLink = null,
            otherLinks = listOf(
                "Terms and Conditions" to "/lovenearby-terms",
                "Safety Advice" to "/lovenearby-safety"
            )
        )
        AppCard(
            titleContent = {
                SpanText("nQuiz")
            },
            description = "Test your knowledge and win prizes!",
            status = "In Development",
            statusColor = Colors.DeepSkyBlue,
            borderColor = Color.rgb(0x29db8b),
            googlePlayLink = null,
            appStoreLink = null
        )
    }
}